import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Event } from '../tracking';

interface TrackItemSelectClickOptions {
  listLength: number;
  listPosition: number;
  title: string;
}

const enum Element {
  Drawer = 'drawer',
  Checkbox = 'checkbox',
  Button = 'button',
  Icon = 'icon',
}

export const trackDrawerView = (listLength: number) =>
  dispatchTrackingEventGA4({
    event: Event.View,
    element: Element.Drawer,
    list_length: listLength,
  });

export const trackAlternativeVariantClick = ({
  listLength,
  listPosition,
  title,
}: TrackItemSelectClickOptions) =>
  dispatchTrackingEventGA4({
    event: Event.Click,
    element: Element.Checkbox,
    title,
    list_length: listLength,
    list_position: listPosition,
  });

export const trackSaveButtonClick = (buttonText: string) =>
  dispatchTrackingEventGA4({
    event: Event.Click,
    element: Element.Button,
    button_text: buttonText,
    interaction: 'close',
  });

export const trackDrawerClose = () =>
  dispatchTrackingEventGA4({
    event: Event.Click,
    element: Element.Icon,
    drawer: 'open',
    interaction: 'close',
  });
